import {Component, OnInit, OnDestroy, ChangeDetectorRef} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiService} from '../../../services/api.service';
import {UtilityService} from '../../../services/utility-service';
import {Location} from '@angular/common';
import {ErrorService} from '../../../shared/error-page/service/error-service';
import {LoanDetailsResponseVo} from '../../../model/loanDetailsResponseVo';
import {Title} from '@angular/platform-browser';
import {Subscription} from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-loan-details',
  templateUrl: './loan-details.component.html',
  styleUrls: ['./loan-details.component.scss']
})
export class LoanDetailsComponent implements OnInit, OnDestroy {
  loanNumber: string;
  containsError = false;
  errorMsg: string;
  responseDetails: LoanDetailsResponseVo;
  title = 'Loan Details';
  private errorSub: Subscription;

  constructor(private router: ActivatedRoute, private service: ApiService, private  routerCore: Router,
              private errorService: ErrorService, private utilService: UtilityService, private location: Location,
              private titleService: Title, private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    /** Receive loan Number from last navigation */
    this.router.queryParams.subscribe(params => {
      this.loanNumber = params.loanNumber;
      this.getLoanDetails(this.loanNumber);
      this.cdr.detectChanges();
    });

    sessionStorage.setItem('currentSubMenuOption', '');

  }
  /** cancel button - get back to result page */
  public cancel() {
    this.location.back();
  }
  /** Detailed page print view*/
  public printComponent() {
    window.print();
  }
  /** Call backend API to get the loan details */
  getLoanDetails(loanNumber: string) {

    this.service.getLoanDetailResult(loanNumber).subscribe(
      (data: LoanDetailsResponseVo) => {
        this.responseDetails = this.formatLoanDetails(data);
        this.cdr.detectChanges();
      },
      error => {
        this.errorService.announceError(error);
      }
    );
    this.errorAnnouncement();
  }

  errorAnnouncement() {
    // error announcement
    this.errorSub = this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        this.errorMsg = message;
        this.containsError = true;
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    if (this.errorSub) {
      this.errorSub.unsubscribe();
    }
  }

  /** Format the API response to readable format */
  formatLoanDetails(response: LoanDetailsResponseVo): LoanDetailsResponseVo {
    if (response.loanEntityValue == null) {
      return null;
    }
    /** Convert convertMillisecToDate */
    if (response.loanEntityValue.lnFndgDt != null) {
      response.loanEntityValue.lnFndgDt.date = this.utilService.convertMillisecToDate(response.loanEntityValue.lnFndgDt.date);
    }
    /** Convert convertMillisecToDate */
    if (response.loanEntityValue.lstStatChangeDt != null) {
      response.loanEntityValue.lstStatChangeDt.date = this.utilService.convertMillisecToDateTime(response.loanEntityValue.lstStatChangeDt.date);
    }
    /** Convert convertMillisecToDate */
    if (response.loanEntityValue.lnSchdClsngDt != null) {
      response.loanEntityValue.lnSchdClsngDt.date = this.utilService.convertMillisecToDate(response.loanEntityValue.lnSchdClsngDt.date);
    }
    /** Convert convertMillisecToDate */
    if (response.loanEntityValue.brwrBirDt != null) {
      response.loanEntityValue.brwrBirDt.date = this.utilService.convertMillisecToDate(response.loanEntityValue.brwrBirDt.date);
    }
    /** Convert convertMillisecToDate */
    if (response.loanEntityValue.propStrcBltYr != null) {
      response.loanEntityValue.propStrcBltYrShow = '' + this.utilService.convertMillisecToDateYearOnly(response.loanEntityValue.propStrcBltYr.date);
    }
    /** Convert convertMillisecToDate */
    if (response.loanEntityValue.lnFstPiPmtChgDt != null) {
      response.loanEntityValue.lnFstPiPmtChgDt.date = this.utilService.convertMillisecToDate(response.loanEntityValue.lnFstPiPmtChgDt.date);
    }
    /** Convert convertMillisecToDate */
    if (response.loanEntityValue.lnFstDsbtDt != null) {
      response.loanEntityValue.lnFstDsbtDt.date = this.utilService.convertMillisecToDate(response.loanEntityValue.lnFstDsbtDt.date);
    }
    /** Convert convertMillisecToDate */
    if (response.loanEntityValue.tenureConvFactor != null) {
      response.loanEntityValue.tenureConvFactor.amount = parseFloat(response.loanEntityValue.tenureConvFactor.amount).toFixed(2);
    }
    /** Convert convertMillisecToDate */
    if (response.loanEntityValue.expdAvgIdxRt != null) {
      response.loanEntityValue.expdAvgIdxRt.amount = parseFloat(response.loanEntityValue.expdAvgIdxRt.amount).toFixed(2);
    }
    /** Convert amount value to float */
    if (response.loanEntityValue.lnInitIntRt != null) {
      response.loanEntityValue.lnInitIntRt.amount = parseFloat(response.loanEntityValue.lnInitIntRt.amount).toFixed(4);
    }
    /** Convert amount value to float */
    if (response.loanEntityValue.expdAvgIntRt != null) {
      response.loanEntityValue.expdAvgIntRt.amount = parseFloat(response.loanEntityValue.expdAvgIntRt.amount).toFixed(4);
    }

    /** Convert amount value to float */
    if (response.loanEntityValue.lnIdxRt != null) {
      response.loanEntityValue.lnIdxRt.amount = parseFloat(response.loanEntityValue.lnIdxRt.amount).toFixed(4);
    }
    /** Convert amount value to float */
    if (response.loanEntityValue.mtgMrgnRt != null) {
      response.loanEntityValue.mtgMrgnRt.amount = parseFloat(response.loanEntityValue.mtgMrgnRt.amount).toFixed(4);
    }
    /** Convert amount value to float */
    if (response.loanEntityValue.mtgIntRtMin != null) {
      response.loanEntityValue.mtgIntRtMin.amount = parseFloat(response.loanEntityValue.mtgIntRtMin.amount).toFixed(2);
    }
    /** Convert amount value to float */
    if (response.loanEntityValue.mtgCeilMtgIntRt != null) {
      response.loanEntityValue.mtgCeilMtgIntRt.amount = parseFloat(response.loanEntityValue.mtgCeilMtgIntRt.amount).toFixed(4);
    }


    /** Get the label value from utilService */
    this.utilService.productCode.forEach(function(part1, index1, array1) {

      if (array1[index1].value === String(response.loanEntityValue.prdctTypCd)) {
        response.loanEntityValue.prdctTypCd = array1[index1].label;
      }
    });

    /** Get the label value from utilService */
    this.utilService.loanStatus.forEach(function(part1, index1, array1) {

      if (array1[index1].value === String(response.loanEntityValue.lnStatCd)) {
        response.loanEntityValue.lnStatCd = array1[index1].label;
      }

    });


    /** Get the label value from utilService */
    this.utilService.gender.forEach(function(part1, index1, array1) {

      if (array1[index1].value === String(response.loanEntityValue.brwrGndrTypCd)) {
        response.loanEntityValue.brwrGndrTypCd = array1[index1].label;
      }
    });
    /** Get the label value from utilService */
    this.utilService.gender.forEach(function(part1, index1, array1) {

      if (array1[index1].value === String(response.loanEntityValue.cbrwrGndrTypCd)) {
        response.loanEntityValue.cbrwrGndrTypCd = array1[index1].label;
      }
    });
    /** Get the label value from utilService */
    this.utilService.paymentPln.forEach(function(part1, index1, array1) {

      if (array1[index1].value === String(response.loanEntityValue.lnPmtPlanTypCd)) {
        response.loanEntityValue.lnPmtPlanTypCd = array1[index1].label;
      }
    });

    /** Get the label value from utilService */
    this.utilService.racer.forEach(function(part1, index1, array1) {

      if (array1[index1].value === String(response.loanEntityValue.brwrRcCd1)) {
        response.loanEntityValue.brwrRcCd1 = array1[index1].label;
      }
    });

    /** Get the label value from utilService */
    this.utilService.racer.forEach(function(part1, index1, array1) {

      if (array1[index1].value === String(response.loanEntityValue.brwrRcCd2)) {
        response.loanEntityValue.brwrRcCd2 = array1[index1].label;
      }
    });

    /** Get the label value from utilService */
    this.utilService.racer.forEach(function(part1, index1, array1) {

      if (array1[index1].value === String(response.loanEntityValue.brwrRcCd3)) {
        response.loanEntityValue.brwrRcCd3 = array1[index1].label;
      }
    });

    /** Get the label value from utilService */
    this.utilService.racer.forEach(function(part1, index1, array1) {

      if (array1[index1].value === String(response.loanEntityValue.brwrRcCd4)) {
        response.loanEntityValue.brwrRcCd4 = array1[index1].label;
      }
    });


    /** Get the label value from utilService */
    this.utilService.racer.forEach(function(part1, index1, array1) {

      if (array1[index1].value === String(response.loanEntityValue.brwrRcCd5)) {
        response.loanEntityValue.brwrRcCd5 = array1[index1].label;
      }
    });


    /** Get the label value from utilService */
    this.utilService.racer.forEach(function(part1, index1, array1) {

      if (array1[index1].value === String(response.loanEntityValue.cbrwrRcCd1)) {
        response.loanEntityValue.cbrwrRcCd1 = array1[index1].label;
      }
    });

    /** Get the label value from utilService */
    this.utilService.racer.forEach(function(part1, index1, array1) {

      if (array1[index1].value === String(response.loanEntityValue.cbrwrRcCd2)) {
        response.loanEntityValue.cbrwrRcCd2 = array1[index1].label;
      }
    });

    /** Get the label value from utilService */
    this.utilService.racer.forEach(function(part1, index1, array1) {

      if (array1[index1].value === String(response.loanEntityValue.cbrwrRcCd3)) {
        response.loanEntityValue.cbrwrRcCd3 = array1[index1].label;
      }
    });


    /** Get the label value from utilService */
    this.utilService.racer.forEach(function(part1, index1, array1) {

      if (array1[index1].value === String(response.loanEntityValue.cbrwrRcCd4)) {
        response.loanEntityValue.cbrwrRcCd4 = array1[index1].label;
      }
    });


    /** Get the label value from utilService */
    this.utilService.racer.forEach(function(part1, index1, array1) {

      if (array1[index1].value === String(response.loanEntityValue.cbrwrRcCd5)) {
        response.loanEntityValue.cbrwrRcCd5 = array1[index1].label;
      }
    });

    /** Get the label value from utilService */
    this.utilService.ethnicity.forEach(function(part1, index1, array1) {

      if (array1[index1].value === String(response.loanEntityValue.cbrwrEthcyCd)) {
        response.loanEntityValue.cbrwrEthcyCd = array1[index1].label;
      }
    });


    /** Get the label value from utilService */
    this.utilService.ethnicity.forEach(function(part1, index1, array1) {

      if (array1[index1].value === String(response.loanEntityValue.brwrEthcyCd)) {
        response.loanEntityValue.brwrEthcyCd = array1[index1].label;
      }
    });

    /** Get the label value from utilService */
    this.utilService.dwellingType.forEach(function(part1, index1, array1) {

      if (array1[index1].value === String(response.loanEntityValue.propDwlTypCd)) {
        response.loanEntityValue.propDwlTypCd = array1[index1].label;
      }
    });

    /** Get the label value from utilService */
    this.utilService.inrateType.forEach(function(part1, index1, array1) {
      if (response.loanEntityValue.loanInterestRateTypeCode != null) {
        if (array1[index1].value === String(response.loanEntityValue.loanInterestRateTypeCode.code)) {
          response.loanEntityValue.loanInterestRateTypeCode.code = array1[index1].label;
        }
      }
    });

    /* Convert FHA Case# Assignment Date and Co-borrower Date of Birth to MM/DD/YYYY format */
    if (response.loanEntityValue.cbrwrBirDt != null)
    {
      response.loanEntityValue.cbrwrBirDt =
          this.utilService.convertMillisecToDate(response.loanEntityValue.cbrwrBirDt['date']);
    }

    if (response.loanEntityValue.fhaCaseAssignmentDate != null)
    {
      response.loanEntityValue.fhaCaseAssignmentDate =
          this.utilService.convertMillisecToDate(response.loanEntityValue.fhaCaseAssignmentDate['date']);
    }

    return response;
  }
}
